import React from "react";
import { useNavigate } from "react-router-dom";

import { Box, Stack, Typography } from "@mui/material";
import moment from "moment";

import { PageHeaderMui } from "../../components/index.js";
import { ShieldPersonIcon } from "../../components/mui/index.js";
import ChipStatus from "../../components/mui/status/status.component.js";
import EnhancedTable from "../../components/mui/enhanced-table/enhanced-table.component.js";
import { toasterService } from "../../components/toaster/toaster-service.js";
import { getRunbooks } from "../../shared/release-runbook.api.js";

export const RunbookList = () => {
  const navigate = useNavigate();

  const headCells = [
    {
      key: "code",
      label: "Code",
      width: "18%",
      displayComponent: ({ data }) => (
        <Typography sx={{ fontFamily: "monospace", fontSize: "14px" }}>
          {data.code}
        </Typography>
      ),
    },
    {
      key: "name",
      label: "Name",
      width: "24%",
      displayComponent: ({ data }) => (
        <Typography sx={{ fontWeight: "bold" }}>{data.name || "--"}</Typography>
      ),
    },
    {
      noSort: true,
      key: "status",
      label: "Status",
      width: "10%",
      displayComponent: ({ data }) => <ChipStatus status={data.status} />,
    },
    {
      noSort: true,
      key: "tested_count",
      label: "Ticked",
      width: "10%",
      displayComponent: ({ data }) => (
        <Typography sx={{ fontSize: "14px" }}>
          {data.tested_count} / {data.item_count}
        </Typography>
      ),
    },
    {
      key: "generated_when",
      label: "Generated",
      width: "20%",
      displayComponent: ({ data }) => (
        <Typography sx={{ fontSize: "14px" }}>
          {data.generated_when
            ? moment(data.generated_when).format("MMM D, YYYY h:mm a")
            : "--"}
        </Typography>
      ),
    },
    {
      noSort: true,
      key: "generated_by_name",
      label: "Generated by",
      width: "18%",
      displayComponent: ({ data }) => (
        <Typography sx={{ fontSize: "14px" }}>
          {data.generated_by_name || "--"}
        </Typography>
      ),
    },
  ];

  return (
    <div className="wrapper">
      <PageHeaderMui type="Release Runbooks" icon={<ShieldPersonIcon />} />
      <Stack spacing={2}>
        <Box sx={{ px: "20px", pt: "20px" }}></Box>
        <div className="mui-wrapper">
          <EnhancedTable
            type="Release Runbooks"
            headCells={headCells}
            api={getRunbooks}
            defaultSort={"-generated_when"}
            errors={() => toasterService.error("Could not load the runbooks.")}
            handleRowClick={(row) => navigate(`/release-runbook/${row.code}`)}
          />
        </div>
      </Stack>
    </div>
  );
};
